export type EntityProfileKind = "character" | "location" | "prop"

export type EntityProfileSectionDef = {
  key: string
  label: string
  /** Стабильный числовой id для mention attrs (не используется при парсинге). */
  mentionId: number
}

const CHARACTER_SECTIONS: EntityProfileSectionDef[] = [
  { key: "height", label: "Рост", mentionId: 1000 },
  { key: "role", label: "Роль", mentionId: 1001 },
  { key: "short_description", label: "Краткое описание", mentionId: 1002 },
  { key: "personality", label: "Характер", mentionId: 1003 },
  { key: "appearance_summary", label: "Внешность", mentionId: 1004 },
  { key: "visual_prompt_summary", label: "Визуальные детали", mentionId: 1005 },
  { key: "gait", label: "Походка", mentionId: 1006 },
  { key: "voice", label: "Голос", mentionId: 1007 },
]

const LOCATION_SECTIONS: EntityProfileSectionDef[] = [
  { key: "description", label: "Описание", mentionId: 2001 },
  { key: "mood", label: "Настроение/атмосфера", mentionId: 2002 },
  { key: "visual_traits", label: "Визуальные черты", mentionId: 2003 },
]

const PROP_SECTIONS: EntityProfileSectionDef[] = [
  { key: "diagonal_size", label: "Размер по диагонали", mentionId: 3000 },
  { key: "category", label: "Категория", mentionId: 3001 },
  { key: "short_description", label: "Краткое описание", mentionId: 3002 },
  { key: "visual_description", label: "Визуальное описание", mentionId: 3003 },
  { key: "purpose", label: "Назначение", mentionId: 3004 },
  { key: "materials", label: "Материалы", mentionId: 3005 },
  { key: "features", label: "Особенности", mentionId: 3006 },
  { key: "consistency_notes", label: "Заметки по консистентности", mentionId: 3007 },
]

export function entityProfileSections(kind: EntityProfileKind): EntityProfileSectionDef[] {
  if (kind === "character") return CHARACTER_SECTIONS
  if (kind === "location") return LOCATION_SECTIONS
  return PROP_SECTIONS
}

/** Каноническая секция по ключу (для paste/serialize, когда autocomplete-items отфильтрованы). */
export function attrSectionByKey(key: string): EntityProfileSectionDef | null {
  for (const kind of ["character", "location", "prop"] as const) {
    const found = entityProfileSections(kind).find((def) => def.key === key)
    if (found) return found
  }
  return null
}
